import {IBaseFormFieldSettings} from "../base-form-field.settings";

export interface IHiddenFieldSettings extends IBaseFormFieldSettings {
  type: 'number' | 'text';
}
